module.exports = __webpack_public_path__ + "img/boxio_ad_scaled.50fc12d0.jpg";